// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import moment from "moment";
import { Tooltip, Input } from "@revvsales/components";

// import moment from "moment";

// Components Imports
import { Dropdown } from "../../../../commonComponents";
import AssetCreateDocumentPopup from "../../AssetHeader/AssetCreateDocumentPopup";

// Actions Imports

// Internal Imports
import { GlobalUtils } from "../../../../utils";
import { ASSET } from "../../../../constants";
import DropdownContainer from "../../DropdownContainer";
import { checkAssetPermission } from "../../method";
import AddRecipientsPopup from "../../../DocumentApprovalPopupNew/AddRecipientsPopup";
import DocStatusUpdatePopup from "../../../DocumentApprovalPopupNew/DocStatusUpdatePopup";
import DOCUMENT_ICO from "../../../../assets/document-icons/doc.png";
import FOLDER_ICO from "../../../../assets/document-icons/folder.png";
import LINKED_FOLDER_ICO from "../../../../assets/document-icons/linked_folder.png";
import PDF_ICO from "../../../../assets/document-icons/pdf.png";

// Destructuring
const {
  formatDate,
  writeDataToLocalStorage,
  readDataFromLocalStorage,
  truncateString,
} = GlobalUtils;
const { ASSET_PAGE_URL, ASSET_ITEM_TYPES, ASSET_ITEM_SETTING_OPTIONS } = ASSET;
class AssetItem extends Component {
  assetItemSettingDropdownRef = React.createRef();

  state = {
    showAddRecipientsPopup: false,
    showAssetItemSettingDropdown: false,
    showCreateDocPopup: false,
    showDocStatusUpdateModal: false,
    showStatusDropdown: false,
    showTagsDropdown: false,
    activeAssetStatusColumn: null,
    activeAssetTagColumn: null,
  };

  _toggleStatusDropdown = () => {
    if (this.state.showStatusDropdown) {
      if (this.state.activeAssetStatusColumn) {
        // setTimeout(() => {
        this.setState({ activeAssetStatusColumn: null });
        // }, 1000);
      }
    } else {
      this.setState({
        activeAssetStatusColumn: "STATUS",
        activeAssetTagColumn: null,
      });
    }
    this.setState(prevState => ({
      showStatusDropdown: !prevState.showStatusDropdown,
    }));
  };

  _toggleTagsDropdown = () => {
    if (this.state.showTagsDropdown) {
      if (this.state.activeAssetTagColumn) {
        setTimeout(() => {
          this.setState({ activeAssetTagColumn: null });
        }, 1000);
      }
    } else {
      this.setState({
        activeAssetTagColumn: "TAGS",
        activeAssetStatusColumn: null,
      });
    }
    this.setState(prevState => ({
      showTagsDropdown: !prevState.showTagsDropdown,
    }));
  };

  _toggleCreateDocPopup = () => {
    this.setState(prevState => ({
      showCreateDocPopup: !prevState.showCreateDocPopup,
    }));
  };

  handleStatusDropdownCloseOutside = () => {
    const { showStatusDropdown, activeAssetStatusColumn } = this.state;
    if (showStatusDropdown) {
      this.setState({ showStatusDropdown: !showStatusDropdown });
      if (activeAssetStatusColumn) {
        setTimeout(() => {
          this.setState({ activeAssetStatusColumn: null });
        }, 1000);
      }
    }
  };

  handleTagsDropdownCloseOutside = () => {
    const { showTagsDropdown, activeAssetTagColumn } = this.state;
    if (showTagsDropdown) {
      this.setState({ showTagsDropdown: !showTagsDropdown });
      if (activeAssetTagColumn) {
        setTimeout(() => {
          this.setState({ activeAssetTagColumn: null });
        }, 1000);
      }
    }
  };

  _decideAssetIcon = folderType => {
    if (this.props.isCRMRootFolder) {
      return LINKED_FOLDER_ICO;
    }
    switch (folderType) {
      case ASSET_ITEM_TYPES.FOLDER:
        return FOLDER_ICO;
      case ASSET_ITEM_TYPES.PDF:
        return PDF_ICO;
      case ASSET_ITEM_TYPES.DOCUMENT:
      case ASSET_ITEM_TYPES.DOCUMENT_FORM:
      case ASSET_ITEM_TYPES.EXTERNAL_QUOTE:
        return DOCUMENT_ICO;
      default:
        return DOCUMENT_ICO;
    }
  };

  _decideAssetIconClassName = folderType => {
    switch (folderType) {
      case ASSET_ITEM_TYPES.FOLDER:
        return "folder";
      case ASSET_ITEM_TYPES.PDF:
        return "pdf";
      case ASSET_ITEM_TYPES.DOCUMENT:
      case ASSET_ITEM_TYPES.DOCUMENT_FORM:
      case ASSET_ITEM_TYPES.EXTERNAL_QUOTE:
        return "file";
      default:
        return "file";
    }
  };

  _getAssetFolderUrl = () => {
    const {
      docNo,
      folderId,
      folderName,
      folderType,
      opportunityId,
      opportunityRoot,
    } = this.props;

    // Check, If the current item is a "Folder" or Not
    let isFolder = false;
    if (folderType === ASSET_ITEM_TYPES.FOLDER) {
      isFolder = true;
    }
    let url = "";
    if (isFolder) {
      url = `/${ASSET_PAGE_URL}/${folderName
        .toLocaleLowerCase()
        .split(" ")
        .join("-")}/${folderId}`;

      if (opportunityRoot && opportunityId) {
        url = `${url}/?opp_id=${opportunityId}`;
      }
    } else {
      url = `/documents/${docNo}`;
    }
    return encodeURI(encodeURI(url));
  };

  _handleDownloadDoc = docNo => {
    window.open(`/documents/${docNo}?download=pdf`, "_blank");
  };

  // this sets value in localstorage for document back button navigation
  _setDocBackBtnData = () => {
    if (
      this.props.folderType === ASSET_ITEM_TYPES.DOCUMENT ||
      this.props.folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM
    ) {
      writeDataToLocalStorage("documentPageSource", "assets");
    }
  };

  _dropdownOptionsData = () => {
    const {
      docNo,
      folderId,
      fileId,
      folderType,
      folderName,
      itemOwner,
      folderParentId,
      isCRMRootFolder,
      itemAccessLevel,
      toggleActionDropdown,
    } = this.props;
    const selectedItem = {
      items: [
        {
          folderId,
          folderType,
          folderName,
          fileId,
          itemOwner,
          accessLevel: itemAccessLevel,
        },
      ],
      ids: [folderId],
      parentId: folderParentId,
    };
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const options = [];
    const isFileType =
      folderType === ASSET_ITEM_TYPES.DOCUMENT ||
      folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM ||
      folderType === ASSET_ITEM_TYPES.PDF;
    const IS_DOC_OWNER = itemOwner.id === CURRENT_USER.id;

    ASSET_ITEM_SETTING_OPTIONS.forEach(option => {
      switch (option.id) {
        case "rename": {
          const hasRenamePermission = checkAssetPermission(itemAccessLevel);
          if (hasRenamePermission && !isCRMRootFolder) {
            options.push({
              ...option,
              action: () =>
                toggleActionDropdown(
                  "showAssetItemRenamePopup",
                  true,
                  selectedItem,
                ),
            });
          }
          break;
        }
        case "delete": {
          const type = itemAccessLevel === "EDIT" ? "DELETE" : null;
          const hasDeletePermission = checkAssetPermission(
            itemAccessLevel,
            type,
          );
          if (hasDeletePermission && !isCRMRootFolder) {
            options.push({
              ...option,
              action: () =>
                toggleActionDropdown(
                  "showDeleteItemsPopup",
                  true,
                  selectedItem,
                ),
            });
          }
          break;
        }
        case "addCollaborator": {
          const hasAddCollabPermission = checkAssetPermission(itemAccessLevel);
          if (hasAddCollabPermission) {
            options.push({
              ...option,
              action: () =>
                toggleActionDropdown(
                  "showAssetCollaboratorPopup",
                  true,
                  selectedItem,
                ),
            });
          }
          break;
        }
        case "clone": {
          const hasAddCollabPermission = checkAssetPermission(itemAccessLevel);
          if (
            hasAddCollabPermission &&
            (folderType === ASSET_ITEM_TYPES.DOCUMENT ||
              folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM ||
              folderType === ASSET_ITEM_TYPES.PDF)
          ) {
            options.push({
              ...option,
              action: () => toggleActionDropdown("clone", false, selectedItem),
            });
          }
          break;
        }
        case "moveToFolder": {
          const type = itemAccessLevel === "EDIT" ? "MOVE" : null;
          const hasMovePermission = checkAssetPermission(itemAccessLevel, type);
          if (hasMovePermission && !isCRMRootFolder) {
            options.push({
              ...option,
              action: () =>
                toggleActionDropdown(
                  "showMoveToFolderPopup",
                  true,
                  selectedItem,
                ),
            });
          }
          break;
        }
        case "downloadDoc": {
          if (!isCRMRootFolder && isFileType && IS_DOC_OWNER) {
            options.push({
              ...option,
              action: () => this._handleDownloadDoc(docNo),
            });
          }
          break;
        }
        case "sendToSomeone": {
          if (!isCRMRootFolder && isFileType && IS_DOC_OWNER) {
            options.push({
              ...option,
              action: () =>
                this._toggleModalPopUp(
                  "showAddRecipientsPopup",
                  true,
                  selectedItem,
                ),
            });
          }
          break;
        }
        default:
      }
    });

    options.forEach((option, index) => {
      if (index === options.length - 2) {
        option.isBottomLine = true;
      }
    });

    return {
      icon: "caret-circle-down",
      iconType: "fas",
      position: "bottom",
      title: "",
      selectedClassNameIdent: "",
      className: "assetitem-settings-dropdown",
      options,
    };
  };

  _toggleAssetItemSettingDropdownHandler = () => {
    // attach/remove event handler
    if (!this.state.showAssetItemSettingDropdown) {
      document.addEventListener(
        "click",
        this._handleAssetItemSettingDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleAssetItemSettingDropdownOutsideClick,
        false,
      );
    }

    this.setState(prevState => ({
      showAssetItemSettingDropdown: !prevState.showAssetItemSettingDropdown,
    }));
  };

  _handleAssetItemSettingDropdownOutsideClick = e => {
    const node = this.assetItemSettingDropdownRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleAssetItemSettingDropdownHandler();
  };

  _onCheckboxChangeHandler = (folderId, hasEditPermission) => {
    const {
      folderType,
      folderName,
      opportunityId,
      folderParentId,
      opportunityRoot,
      selectAssetItem,
      isCRMRootFolder,
      selectedCheckboxItems,
      fileId,
    } = this.props;
    if (hasEditPermission && !isCRMRootFolder) {
      const data = {
        flag: selectedCheckboxItems[folderId]
          ? !selectedCheckboxItems[folderId].flag
          : true,
        type: folderType,
        name: folderName,
        parentId: folderParentId,
        docId:
          folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM ||
          folderType === ASSET_ITEM_TYPES.DOCUMENT
            ? fileId
            : null,
        meta: { opportunityId, opportunityRoot },
      };

      selectAssetItem(folderId, data);
    }
  };

  _navigateToAssetItem = () => {
    const {
      docNo,
      folderId,
      history,
      folderName,
      folderType,
      isExtQuote,
      opportunityId,
      opportunityRoot,
    } = this.props;

    if (isExtQuote) {
      this._toggleCreateDocPopup();
    } else {
      // Check, If the current item is a "Folder" or Not
      let isFolder = false;
      if (folderType === ASSET_ITEM_TYPES.FOLDER) {
        isFolder = true;
      }
      let url = null;
      if (isFolder) {
        url = `/${ASSET_PAGE_URL}/${folderName
          .toLocaleLowerCase()
          .split(" ")
          .join("-")}/${folderId}`;

        console.debug("opportunityId", opportunityId);
        if (opportunityRoot && opportunityId) {
          url = `${url}/?opp_id=${opportunityId}`;
        }
      } else {
        url = `/documents/${docNo}`;
      }
      if (url) {
        history.push(url);
      }
    }
  };

  _stopEventPropogation = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  _getExtQuoteItemsRow = () => (
    <div
      className="assetitem-row"
      onClick={this._navigateToAssetItem}
      onKeyPress={() => {}}
      tabIndex="0"
      role="button">
      <div className="assetitem-col col-label">
        <span className="assetitem-icon-wrapper">
          <FontAwesomeIcon
            icon={["fal", "file-alt"]}
            className="assetitem-icon file extquote-file-icon "
          />
          <FontAwesomeIcon
            icon={["far", "link"]}
            className="folder-link-icon"
          />
        </span>

        <span className="assetitem-label">
          <span className="assetitem-label-text">{this.props.folderName}</span>
        </span>
      </div>
      {this.props.assetColumns &&
        this.props.assetColumns.map(column =>
          this._getExtQuoteColumn(column.id, column.isActive),
        )}
      <div className="assetitem-settings" />
    </div>
  );

  _getExtQuoteColumn = (id, isActive) => {
    const { itemOwner, folderId } = this.props;
    if (isActive) {
      switch (id) {
        case "tagsType":
          return (
            <div className="assetitem-col col-type contains-dropdown">
              <span className="assetitem-type folder">CRM Quote Table</span>
            </div>
          );
        case "status":
          return <div className="assetitem-col col-status contains-dropdown" />;
        case "modifiedBy":
          return (
            <div className="assetitem-col col-modify">
              <span className="assetitem-userprofile-img ">
                {itemOwner && itemOwner.image_url && (
                  <img alt="Revv" src={itemOwner.image_url} />
                )}
              </span>
              <span className="assetitem-modified-date">
                {itemOwner && itemOwner.updated_at
                  ? formatDate(itemOwner.updated_at, "lll")
                  : "-"}
              </span>
            </div>
          );
        case "docuId":
          return (
            <div
              className="assetitem-col col-docuid"
              onClick={this._navigateToAssetItem}
              onKeyPress={() => {}}
              tabIndex="0"
              role="button">
              <span className="assetitem-col-label assetitem-docuid">
                {folderId}
              </span>
            </div>
          );
        case "contact":
          return (
            <div className="assetitem-col col-contact">
              <span className="assetitem-col-label assetitem-contact">-</span>
            </div>
          );
        case "turnarounddate":
          return (
            <div className="assetitem-col col-turnarounddate">
              <span className="assetitem-modified-date">
                {itemOwner && itemOwner.deadline_date
                  ? formatDate(itemOwner.deadline_date, "ll")
                  : "-"}
              </span>
            </div>
          );
        default:
          return null;
      }
    } else return null;
  };

  _getTitleColumn = isCheckboxChecked => {
    const {
      docNo,
      folderId,
      folderName,
      index,
      isCRMRootFolder,
      folderType,
      isAnyItemSelected,
      selectedCheckboxItems,
      updatedAt,
      itemAccessLevel,
    } = this.props;

    // Check, If the current item is a "Folder" or Not
    let isFolder = false;
    if (folderType === ASSET_ITEM_TYPES.FOLDER) {
      isFolder = true;
    }

    const type = itemAccessLevel === "EDIT" ? "DISABLE_CHECKBOX" : null;
    const hasCheckboxPermission = checkAssetPermission(itemAccessLevel, type);

    // Calculate the diff of last edited datetime to show the "Recent" tag
    // for items edited in the last 24 hours only for
    let showRecentTag = false;
    let calculateDiff = null;
    if (index <= 1) {
      const currentDate = new Date();
      const updatedDate = GlobalUtils.formatDate(updatedAt, "lll");
      calculateDiff = moment(moment(currentDate)).diff(updatedDate, "hours");
      if (calculateDiff <= 24) {
        showRecentTag = true;
      }
    }

    return (
      <div
        className={`assetitem-col col-label ${
          isAnyItemSelected ||
          (selectedCheckboxItems.ALL ? selectedCheckboxItems.ALL.flag : false)
            ? " show-checkbox "
            : ""
        } `}>
        <span className="assetitem-checkbox-wrapper">
          <Input
            checked={isCheckboxChecked}
            disabled={isCRMRootFolder || !hasCheckboxPermission}
            type="checkbox"
            value=""
            onChange={() =>
              this._onCheckboxChangeHandler(folderId, hasCheckboxPermission)
            }
            data-test="assetitem-checkbox-wrapper"
            className="assetitem-checkbox-custom"
          />
        </span>
        <div className="assetitem-icon-wrapper">
          <img
            src={this._decideAssetIcon(folderType)}
            className={`assetitem-icon ${this._decideAssetIconClassName(
              folderType,
            )} ${isCRMRootFolder ? " crmfolder-icon " : ""}`}
            alt="icons"
          />

          {/**
            {!isAnyItemSelected && isCRMRootFolder && (
              <FontAwesomeIcon
              icon={["far", "link"]}
              className="folder-link-icon crmfolder-icon"
              />
            )}
          */}
        </div>

        <Link
          to={this._getAssetFolderUrl(folderName, folderId, docNo, isFolder)}
          onClick={this._setDocBackBtnData}
          className="assetitem-link">
          <span className="assetitem-label">
            <div className="assetitem-label-text">
              {folderName ? truncateString(folderName, 50, true) : null}{" "}
            </div>
            {folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM && (
              <span className="assetitem-form-tag">Form</span>
            )}
            {showRecentTag && <span className="tag-recent">Recent</span>}
            {/* {docNo && (
                    <span className="assetitem-sub-label">{docNo}</span>
                  )} */}
          </span>
        </Link>
      </div>
    );
  };

  _getAssetItemColumn = (id, isActive) => {
    const {
      docNo,
      folderId,
      updatedAt,
      folderType,
      folderTags,
      folderName,
      itemOwner,
      documentStatus,
      fileId,
      turnAroundDate,
      itemAccessLevel,
      documentTags,
    } = this.props;

    // Check, If the current item is a "Folder" or Not
    let isFolder = false;
    if (folderType === ASSET_ITEM_TYPES.FOLDER) {
      isFolder = true;
    }
    let defaultTag = (
      <div>
        <FontAwesomeIcon
          icon={["far", "plus-circle"]}
          color="#70682c"
          className="show-empty-regular"
        />
        <FontAwesomeIcon
          icon={["fas", "plus-circle"]}
          color="#70682c"
          className="show-empty-solid"
        />
      </div>
    );
    if (folderTags && folderTags[0]) {
      [defaultTag] = folderTags;
    }
    let notag = "";
    if (
      !(documentTags && documentTags.name) &&
      !isFolder &&
      folderType !== "PDF"
    ) {
      notag = "assetitem-notag";
    }
    let tagValue = "";
    if (isFolder) {
      tagValue = (
        <div>
          <FontAwesomeIcon icon={["far", "tag"]} color="#70682c" /> Folder
        </div>
      );
    } else if (folderType === "PDF") {
      tagValue = (
        <div>
          <FontAwesomeIcon icon={["far", "tag"]} color="#70682c" /> PDF
        </div>
      );
    } else if (documentTags) {
      if (documentTags.name.length > 10) {
        tagValue = (
          <Tooltip
            placement="top"
            align={{
              offset: [0, 4],
            }}
            overlay={documentTags.name}
            mouseLeaveDelay={0.1}
            overlayClassName="assetitem-tags-tooltip">
            <div>
              <FontAwesomeIcon icon={["far", "tag"]} color="#70682c" />{" "}
              {truncateString(documentTags.name, 8, true)}
            </div>
          </Tooltip>
        );
      } else {
        tagValue = (
          <div>
            <FontAwesomeIcon icon={["far", "tag"]} color="#70682c" />{" "}
            {truncateString(documentTags.name, 10, true)}
          </div>
        );
      }
    } else {
      tagValue = defaultTag;
    }
    const {
      showStatusDropdown,
      showTagsDropdown,
      activeAssetStatusColumn,
      activeAssetTagColumn,
    } = this.state;
    const hasEditPermission = checkAssetPermission(itemAccessLevel);

    // let updatedDateTime = formatDate(updatedAt, "MMM D, YYYY");
    // const currentDate = new Date();
    const updatedDate = GlobalUtils.formatDate(updatedAt, "lll");
    // const calculateDiff = moment(moment(currentDate)).diff(
    //   updatedDate,
    //   "hours",
    // );
    // if (calculateDiff <= 24) {
    //   updatedDateTime = formatDate(updatedAt, "ddd, h:mm A");
    // }

    if (isActive) {
      switch (id) {
        case "tagsType":
          /* ------- Asset Type Section ------- */
          return (
            <div
              className={`assetitem-col col-type contains-dropdown ${
                !isFolder &&
                folderType !== "PDF" &&
                activeAssetTagColumn === "TAGS"
                  ? " active-tag "
                  : ""
              }`}
              key={id}>
              {documentTags && documentTags.name.length > 10 ? (
                <Tooltip
                  placement="top"
                  align={{
                    offset: [0, 4],
                  }}
                  mouseLeaveDelay={0.1}
                  disabled={documentTags}
                  overlay={documentTags && documentTags.name}
                  overlayClassName="assetitem-tags-tooltip">
                  <span
                    onClick={
                      hasEditPermission
                        ? () => this._toggleTagsDropdown()
                        : () => {}
                    }
                    onKeyPress={() => {}}
                    data-id={`tags${docNo}`}
                    role="button"
                    tabIndex="0"
                    className={`assetitem-type ${
                      isFolder || folderType === "PDF" ? "folder" : "tag"
                    } ${notag} `}>
                    {tagValue}
                    {hasEditPermission && (
                      <span
                        className={`dd-arrow ${
                          showTagsDropdown ? "show-dd-open" : ""
                        }`}>
                        <FontAwesomeIcon
                          icon={["far", "angle-down"]}
                          className="asset-angle-down"
                        />
                      </span>
                    )}
                  </span>
                </Tooltip>
              ) : (
                <span
                  onClick={
                    hasEditPermission
                      ? () => this._toggleTagsDropdown()
                      : () => {}
                  }
                  onKeyPress={() => {}}
                  data-id={`tags${docNo}`}
                  role="button"
                  tabIndex="0"
                  className={`assetitem-type ${
                    isFolder || folderType === "PDF" ? "folder" : "tag"
                  } ${notag} `}>
                  {tagValue}
                  {hasEditPermission && (
                    <span
                      className={`dd-arrow ${
                        showTagsDropdown ? "show-dd-open" : ""
                      }`}>
                      <FontAwesomeIcon
                        icon={["far", "angle-down"]}
                        className="asset-angle-down"
                      />
                    </span>
                  )}
                </span>
              )}

              {showTagsDropdown &&
                hasEditPermission &&
                (folderType === ASSET_ITEM_TYPES.DOCUMENT ||
                  folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM) && (
                  <DropdownContainer
                    docID={fileId}
                    id={`tags${docNo}`}
                    type="tags"
                    documentStatus={documentStatus}
                    documentTags={documentTags}
                    showMenu={showTagsDropdown}
                    className="tag-dropdown"
                    closeDropdownContainer={this.handleTagsDropdownCloseOutside}
                  />
                )}
            </div>
          );
        case "status":
          /* ------- Asset Status Section ------- */
          return (
            <div
              className="assetitem-col col-status contains-dropdown"
              key={id}>
              {(folderType === ASSET_ITEM_TYPES.DOCUMENT ||
                folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM) && (
                <div
                  onClick={
                    hasEditPermission ? this._toggleStatusDropdown : () => {}
                  }
                  onKeyPress={() => {}}
                  data-id={`status${docNo}`}
                  role="button"
                  tabIndex="0"
                  className={`assetitem-status ${
                    !hasEditPermission ? " disable-hover " : ""
                  } ${
                    activeAssetStatusColumn === "STATUS" ? "active-status" : ""
                  }`}>
                  <div
                    style={{
                      // stylelint-disable-next-line
                      backgroundColor: documentStatus
                        ? documentStatus.color
                        : "",
                    }}
                    className="status-color-container"
                  />
                  {documentStatus && documentStatus.name.length > 12 ? (
                    <Tooltip
                      placement="top"
                      overlay={documentStatus.name}
                      overlayClassName="assetitem-status-tooltip"
                      mouseLeaveDelay={0.1}
                      align={{
                        offset: [4, 0],
                      }}>
                      <div className="status-color-text">
                        {documentStatus && documentStatus.name
                          ? truncateString(documentStatus.name, 10, true)
                          : null}
                      </div>
                    </Tooltip>
                  ) : (
                    <div className="status-color-text">
                      {documentStatus && documentStatus.name
                        ? truncateString(documentStatus.name, 12, true)
                        : null}
                    </div>
                  )}
                  {hasEditPermission && (
                    <span
                      className={`dd-arrow ${
                        showStatusDropdown ? "show-dd-open" : ""
                      }`}>
                      <FontAwesomeIcon
                        icon={["far", "angle-down"]}
                        className="asset-angle-down"
                      />
                    </span>
                  )}
                  <div
                    style={{
                      backgroundColor: documentStatus
                        ? documentStatus.color
                        : "",
                    }}
                    className="status-color-bg"
                  />
                </div>
              )}
              {showStatusDropdown &&
                hasEditPermission &&
                (folderType === ASSET_ITEM_TYPES.DOCUMENT ||
                  folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM) && (
                  <DropdownContainer
                    docID={fileId}
                    id={`status${docNo}`}
                    type="status"
                    documentStatus={documentStatus}
                    documentTags={documentTags}
                    showMenu={showStatusDropdown}
                    className="status-dropdown"
                    closeDropdownContainer={
                      this.handleStatusDropdownCloseOutside
                    }
                  />
                )}
            </div>
          );
        case "modifiedBy":
          /* ------- Asset Modified by Section ------- */
          return (
            <div className="assetitem-col col-modify" key={id}>
              <Link
                to={this._getAssetFolderUrl(
                  folderName,
                  folderId,
                  docNo,
                  isFolder,
                )}
                onClick={this._setDocBackBtnData}
                className="assetitem-link">
                <Tooltip
                  placement="topLeft"
                  overlay={itemOwner ? itemOwner.name : "-"}
                  align={{
                    offset: [4, 0],
                  }}>
                  <span className="assetitem-userprofile-img ">
                    {itemOwner && itemOwner.image_url && (
                      <img alt="Revv" src={itemOwner.image_url} />
                    )}
                  </span>
                </Tooltip>
                <span className="assetitem-modified-date">
                  {/* {formatDate(lastModified, "lll")} */}
                  {updatedDate}
                </span>
              </Link>
            </div>
          );
        case "docuId":
          return (
            <div className="assetitem-col col-docuid" key={id}>
              <Link
                to={this._getAssetFolderUrl(
                  folderName,
                  folderId,
                  docNo,
                  isFolder,
                )}
                onClick={this._setDocBackBtnData}
                className="assetitem-link">
                {docNo && (
                  <span className="assetitem-col-label assetitem-docuid">
                    {docNo}
                  </span>
                )}
              </Link>
            </div>
          );
        case "contact":
          return (
            <div className="assetitem-col col-contact" key={id}>
              <span className="assetitem-col-label assetitem-contact">-</span>
            </div>
          );
        case "turnarounddate":
          return (
            <div className="assetitem-col col-turnarounddate" key={id}>
              <span className="assetitem-modified-date">
                {turnAroundDate ? formatDate(turnAroundDate, "ll") : null}
              </span>
            </div>
          );
        default:
          return null;
      }
    } else return null;
  };

  _getAssetItemsRow = () => {
    // DECLARATIONS
    const {
      // docNo,
      folderId,
      folderType,
      isCRMRootFolder,
      itemAccessLevel,
      itemOwner,
      selectedCheckboxItems,
    } = this.props;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const IS_DOC_OWNER = itemOwner.id === CURRENT_USER.id;
    const isFileType =
      folderType === ASSET_ITEM_TYPES.DOCUMENT ||
      folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM ||
      folderType === ASSET_ITEM_TYPES.PDF;
    const hasSettingPermission = checkAssetPermission(itemAccessLevel);

    const checkboxType = itemAccessLevel === "EDIT" ? "DISABLE_CHECKBOX" : null;
    const hasCheckboxPermission = checkAssetPermission(
      itemAccessLevel,
      checkboxType,
    );
    let isCheckboxChecked = false;
    if (hasCheckboxPermission) {
      if (!isCRMRootFolder && selectedCheckboxItems[folderId]) {
        isCheckboxChecked = selectedCheckboxItems[folderId].flag;
      }
    }

    return (
      <div className={`assetitem-row ${isCheckboxChecked ? "active-row" : ""}`}>
        {this._getTitleColumn(isCheckboxChecked)}
        {this.props.assetColumns &&
          this.props.assetColumns.map(column =>
            this._getAssetItemColumn(column.id, column.isActive),
          )}
        {/* ASSET SETTING SECTION */}
        {!this.props.isExtQuote && hasSettingPermission && (
          <div className="assetitem-settings">
            <div className="assetitem-action-btns">
              {/* HIDE BELOW OPTION IF IT'S A CRM FOLDER */}
              {!isCRMRootFolder && (
                <Fragment>
                  {/* SHOW SEND & DOWNLOAD OPTIONS ONLY FOR FILE TYPES */}
                  {isFileType && IS_DOC_OWNER && (
                    <Fragment>
                      {/* <span className="ico-wrapper">
                        <Link
                          to={`/documents/${docNo}?download=pdf`}
                          target="_blank"
                          className="assetitem-link">
                          <FontAwesomeIcon
                            icon={["far", "download"]}
                            className="ico"
                          />
                        </Link>
                      </span> */}
                    </Fragment>
                  )}
                </Fragment>
              )}

              {/* HIDE BELOW OPTION FOR ALL TYPES */}
              <Dropdown
                options={this._dropdownOptionsData()}
                showDropdown={this.state.showAssetItemSettingDropdown}
                showDropdownHandler={
                  this._toggleAssetItemSettingDropdownHandler
                }
                dropdownRef={this.assetItemSettingDropdownRef}
                // toolTip={{ placement: "top", overlay: "More options" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  _toggleModalPopUp = (key, flag) => {
    this.setState({
      [key]: flag,
    });
  };

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  render() {
    let popupSpace = null;
    const { showCreateDocPopup } = this.state;
    const {
      documentStatus,
      documentTags,
      fileId,
      folderName,
      itemOwner,
    } = this.props;

    if (showCreateDocPopup) {
      popupSpace = (
        <AssetCreateDocumentPopup
          isOpen={showCreateDocPopup}
          source="assets"
          togglePopup={this._toggleCreateDocPopup}
          extQuoteId={this.props.docID}
        />
      );
    }
    return (
      <div className="assetitem-container">
        {popupSpace}
        {this.props.isExtQuote
          ? this._getExtQuoteItemsRow()
          : this._getAssetItemsRow()}
        {/* MODAL POP UP SECTION */}
        <section>
          {this.state.showAddRecipientsPopup && (
            <AddRecipientsPopup
              document={{
                id: fileId,
                name: folderName,
                documentStatus,
                documentTags,
                created_by: itemOwner,
              }}
              fromAssetPage
              toggleModalPopUp={this._toggleModalPopUp}
              updateMultipleState={this._updateMultipleState}
            />
          )}

          {this.state.showDocStatusUpdateModal && (
            <DocStatusUpdatePopup
              docID={this.props.fileId}
              documentStatus={documentStatus}
              toggleModalPopUp={this._toggleModalPopUp}
            />
          )}
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { assetItemId } = props;
  let folderName = null;
  let folderParentId = null;
  let folderType = null;
  let folderStatus = null;
  let modifiedUserImgUrl = null;
  let createdAt = null;
  let updatedAt = null;
  let docNo = null;
  let folderTags = [];
  let documentStatus = null;
  let docID = null;
  let fileId = null;
  let documentTags = null;
  let isCRMRootFolder = false;
  let opportunityId = null;
  let opportunityRoot = null;
  let isExtQuote = false;
  let itemOwner = null;
  let itemAccessLevel = null;
  let turnAroundDate = null;

  const { assetFolderContent } = state.AssetStore;

  let assetItem;
  if (
    assetFolderContent &&
    assetFolderContent.page &&
    assetFolderContent.page.inodes.length > 0
  ) {
    assetItem = assetFolderContent.page.inodes.find(
      inode => inode.id === assetItemId,
    );
  }

  if (assetItem) {
    if (assetItem.document_status) {
      documentStatus = assetItem.document_status;
    }
    if (assetItem.document_tag) {
      documentTags = assetItem.document_tag;
    }
    docID = assetItem.id;
    fileId = assetItem.file_id;
    docNo = assetItem.doc_no;
    itemAccessLevel = assetItem.access_level;
    folderType = assetItem.type;
    folderName = assetItem.name;
    folderTags = assetItem.tags;
    folderStatus = assetItem.status;
    createdAt = assetItem.created_at;
    updatedAt = assetItem.updated_at;
    opportunityId = assetItem.opportunity_id;
    opportunityRoot = assetItem.opportunity_root;
    folderParentId = assetItem.parent_id;
    modifiedUserImgUrl = assetItem.modified_by
      ? assetItem.modified_by.image_url
      : null;

    if (assetItem.opportunity_id && assetItem.opportunity_root) {
      isCRMRootFolder = true;
    }
    if (folderType === ASSET_ITEM_TYPES.EXTERNAL_QUOTE) {
      isExtQuote = true;
    }
    if (assetItem.owner) {
      itemOwner = assetItem.owner;
    }
    if (assetItem.deadline_date) {
      turnAroundDate = assetItem.deadline_date;
    }
  }

  return {
    docID,
    docNo,
    fileId,
    createdAt,
    updatedAt,
    folderTags,
    folderName,
    folderType,
    isExtQuote,
    itemOwner,
    folderStatus,
    opportunityId,
    folderParentId,
    turnAroundDate,
    itemAccessLevel,
    opportunityRoot,
    isCRMRootFolder,
    modifiedUserImgUrl,
    folderId: assetItemId,
    documentStatus,
    documentTags,
  };
};

export default connect(mapStateToProps)(AssetItem);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetItem/index.js